"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentPageErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.getContentPageErrors = [
    UseCaseError_1.UseCaseError.create('invalidData'),
    UseCaseError_1.UseCaseError.create('notFound'),
    UseCaseError_1.UseCaseError.create('problemInProcess')
];
//# sourceMappingURL=getContentPageErrors.js.map